import LoginPage from './LoginPage';
import connect from './connect';

export default connect(LoginPage);



// WEBPACK FOOTER //
// ./src/app/LoginPage/index.js